export default __webpack_public_path__ + "static/media/cliente3.ea25529b.jpg";